import Alpine from 'alpinejs'

// Handle floating labels for filled fields
document.querySelectorAll('.wpforms-field').forEach(el => {
  let input = el.querySelector('textarea, input')
  if (!input) return

  let toggle = () => {
    el.classList.toggle('wpforms-field-filled', input.value.length > 0)
  }

  toggle()
  input.addEventListener('blur', toggle)
})

// Perform client-side validation for signup forms
if (typeof window.jQuery !== 'undefined') {
  let $ = window.jQuery
  $('[name="signup-hook"]').each(function () {
    let $form = $(this).closest('form')
    let $signupGroups = $form.find('.signup-groups')
    if ($signupGroups.length === 0) return

    $form.on('wpformsBeforeFormSubmit', function (event) {
      let isValid = Alpine.evaluate($signupGroups[0], 'valid')
      if (isValid) return

      event.preventDefault()
      this.reportValidity()
    })
  })
}
